// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__2eDvS","cardTitle":"styles_cardTitle__2RKgJ"};